import axios from 'services/axios'
import trim from 'lodash/trim'
import { API_LOGIN, API_LOGOUT } from 'constants/endpoints'
import { getToken, setToken } from 'helpers/auth'
import { encrypt } from 'helpers/hash'

export const logoutUser = () => {}

/**
 * Login
 *
 * @param {Object} form
 * @param {String} email
 * @return {Object}
 */
export const login = async (form, email = null) => {
  try {
    const { results, isOTP } = await axios.post(API_LOGIN, {
      email: trim(email),
      data: encrypt({
        email: trim(form.email),
        ...form,
      }),
    })

    // Set token
    setToken(results)

    return email ? !isOTP : false
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Login with social
 *
 * @param {String} provider googleplus | facebook | yahoo-oauth2 | apple-id
 * @param {String} token
 * @return {Object}
 */
export const loginWithSocial = async (provider, token) => {
  try {
    const { results } = await axios.post(API_LOGIN, {
      data: encrypt({
        provider,
        socialToken: token,
      }),
    })

    // Set token
    setToken(results)

    return results
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Merge social account
 *
 * @param {String} token
 * @param {String} socialToken
 * @return {Object}
 */
export const mergeSocialAccount = async (token, socialToken) => {
  try {
    const { results } = await axios.post(API_LOGIN, {
      data: encrypt({
        token,
        socialToken,
      }),
    })

    // Set token
    setToken(results)

    return results
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Logout
 */
export const logout = async () => {
  // Get & remove token
  const token = getToken(true)

  if (token) {
    // Call logout api
    try {
      return await axios.post(
        API_LOGOUT,
        {},
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      )
    } catch (error) {
      return Promise.resolve(error)
    }
  }

  return Promise.resolve()
}
